<p-table #dt
         [value]="logs()"
         [paginator]="true"
         [rows]="50"
         [rowsPerPageOptions]="[50, 100, 150]"
         [globalFilterFields]="['level', 'source', 'message']"
         sortField="timestamp"
         [sortOrder]="-1"
         [scrollable]="true"
         [resizableColumns]="true"
         scrollHeight="flex"
         [tableStyle]="{ width: '100%' }"
         data-testid="log-table">
  <ng-template #caption>
    <div class="log-table-search-wrapper">
      <p-iconfield>
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input pInputText
               #searchInput
               type="text"
               class="log-table-search-input"
               [value]="searchTerm"
               (input)="onSearchInput($any($event.target).value, dt)"
               placeholder="Search logs..."
               data-testid="log-table-search-input" />
      </p-iconfield>
      <button type="button"
              class="log-table-search-clear"
              [class.log-table-search-clear-hidden]="!searchTerm"
              (click)="clearSearch(dt)"
              aria-label="Clear search"
              data-testid="log-table-search-clear">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th pSortableColumn="timestamp"
          pResizableColumn
          style="width: 20%">
        Timestamp
        <p-sortIcon field="timestamp" />
      </th>
      <th pSortableColumn="level"
          pResizableColumn
          style="width: 10%">
        Level
        <p-sortIcon field="level" />
      </th>
      <th pSortableColumn="source"
          pResizableColumn
          style="width: 10%">
        Source
        <p-sortIcon field="source" />
      </th>
      <th pSortableColumn="message"
          pResizableColumn>
        Message
        <p-sortIcon field="message" />
      </th>
    </tr>
  </ng-template>
  <ng-template #body
               let-log>
    <tr>
      <td class="log-cell-sticky">{{ log.timestamp ? (log.timestamp | date: "MM/dd/yyyy h:mm:ss a") : "--" }}</td>
      <td class="log-cell-sticky">
        <p-tag [value]="log.level"
               [severity]="getLevelSeverity(log.level)" />
      </td>
      <td class="log-cell-sticky">{{ log.source || "--" }}</td>
      <td class="log-message">{{ log.message }}</td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="4">No logs found.</td>
    </tr>
  </ng-template>
</p-table>